export default "__VITE_ASSET__CRoEDXJH__"